import React, { PureComponent } from 'react';

import Sounds from '../Sounds.js';
import Constants from '../Constants.js';

import './Board.css';

class Tutorial extends PureComponent {

    constructor(props) {
        super(props);

        const stages = [
            {
                text: 'Welcome to ' + Constants.name + ', a puzzle game about forming words and clearing levels!',
                prompt: 'tap anywhere to continue',
                blocksInteraction: true,
            },
            {
                text: 'Your goal in each level is to find and clear all the words, which are hidden in the puzzle.',
                prompt: 'tap anywhere to continue',
                blocksInteraction: true,
            },
            {
                text: 'This is the first level. You\'ll notice that all of the words share a theme, which is hinted at by the level\'s shape.',
                prompt: 'tap anywhere to continue',
                blocksInteraction: true,
            },
            {
                text: 'For example, the theme of this level is \'number\'.',
                prompt: 'tap anywhere to continue',
                blocksInteraction: true,
            },
            {
                text: 'Try starting by clearing the word \'hash\'.',
                prompt: 'tap and drag to form \'hash\'',
                blocksInteraction: false,
            },
            {
                text: 'Nicely done! How about \'symbol\'?',
                prompt: 'tap and drag to form \'symbol\'',
                blocksInteraction: false,
            },
            {
                text: 'Oops! A level might be unsolvable if you clear words in the wrong order. Try tapping the reset button.',
                prompt: 'tap the reset button',
                blocksInteraction: false,
            },
            {
                text: 'Try starting with the word \'social\'.',
                prompt: 'tap and drag to form \'social\'',
                blocksInteraction: false,
            },
            {
                text: 'Looks like you\'re getting the hang of it!',
                prompt: 'clear the rest of the words',
                blocksInteraction: false,
            },
            {
                text: 'Nice work! The rest is up to you. Good luck!',
                prompt: '',
                blocksInteraction: false,
            }
        ]

        this.state = {
            stages: stages,
            currentStage: this.props.currentStage
        }

        this.setStage = this.setStage.bind(this);
        this.advanceStage = this.advanceStage.bind(this);
        this.tapAdvanceStage = this.tapAdvanceStage.bind(this);

        this.text = React.createRef();
        this.prompt = React.createRef();
    }

    // Set the current tutorial stage
    setStage(stage) {
        this.text.current.style.opacity = '0';
        this.text.current.style.transform = 'translateY(-10px)';

        setTimeout(() => {
            this.text.current.style.transform = 'translateY(10px)';
            this.setState({currentStage: stage});

            // Call callback function
            if (typeof this.props.onStageChange === 'function')
                this.props.onStageChange(stage);
        }, 250)

        setTimeout(() => {
            this.text.current.style.opacity = '1';
            this.text.current.style.transform = 'translateY(0px)';
        }, 500);
    }

    // Advance to the next stage
    advanceStage() {
        const c = (this.state.currentStage + 1) % this.state.stages.length;
        this.setStage(c);
    }

    tapAdvanceStage() {
        Sounds.play('tap');
        if (window.TapticEngine) {
            window.TapticEngine.impact({ style: "light" });
        }
        this.advanceStage();
    }




    render() {

        const stage = this.state.stages[this.state.currentStage];

        return (
            <div
                className="TutorialWrapper"
                style={{
                    position: 'absolute',
                    opacity: (this.props.showing ? '1' : '0'),
                    color: (this.props.transitioning ? '#fff' : '#2f3640'),
                    lineHeight: '1.4',
                    pointerEvents: (stage.blocksInteraction && this.props.showing ? 'auto' : 'none'),
                    backgroundColor: (stage.blocksInteraction ? 'transparent' : 'transparent'),
                    transition: 'background-color 250ms, color 400ms, opacity 250ms',
                }}
                onTouchStart={this.tapAdvanceStage}
                onClick={this.tapAdvanceStage}
                onTouchEnd={(e) => {
                    e.preventDefault();
                }}
            >
                <div className="TutorialContainer">
                    <div
                        style={{
                            position: 'relative',
                            left: '50%',
                            marginBottom: '80px',
                            transform: 'translateX(-50%)',
                            width: '80%',
                            maxWidth: '480px',
                            boxSizing: 'border-box',
                            textAlign: 'center',
                        }}
                    >
                        <div
                            style={{
                                position: 'relative',
                                boxSizing: 'border-box',
                                textAlign: 'center',
                                width: '100%',
                                transition: 'opacity 250ms, transform 250ms',
                            }}
                            ref={this.text}
                        >
                            {stage.text}
                            <div
                                style={{
                                    color: '#b2bec3',
                                    fontSize: '14px',
                                    marginTop: '20px',
                                    opacity: '1',
                                    transition: 'opacity 250ms',
                                }}
                            >
                                {stage.prompt}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Tutorial;
